// import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const GET_SHIP_TO_CUSTOMER_SEARCH = gql`
  query GetShipToCustomerSearch(
    $customerId: String!
    $name: String!
    $salesOrgs: [String]!
  ) {
    shipToSearch(customerId: $customerId, name: $name, salesOrgs: $salesOrgs) {
      id
      address {
        name
      }
      salesOrg
    }
  }
`;
